"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  name: 'FileImage',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      document: {},
      attachments: [],
      listLoading: true
    };
  },
  created: function created() {
    var _this = this;
    (0, _request.default)({
      url: "/File/".concat(this.id, "/"),
      method: 'get'
    }).then(function (response) {
      if (response.data) {
        var url1 = response.data.file;
        //   var  updated_url=url1
        console.log(updated_url);
        var updated_url = url1.replace("jk", "jkf");
        //   updated_url=updated_url.replace('jktwo.mailea.cn','jkzc.99zuji.com')
        response.data.file = updated_url;
        _this.document = response.data;
      }
      _this.listLoading = false;
    });
  }
};